import { NgModule } from "@angular/core";
import { MAT_DATE_FORMATS } from "@angular/material/core";
import { DatepickerProvider } from "@nexu-library/utilities";

@NgModule({
  providers: [
    DatepickerProvider.spanish,
    DatepickerProvider.customAdapter,
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: { dateInput: "DD/MM/YYYY" },
        display: {
          dateInput: "DD/MM/YYYY",
          monthYearLabel: "MMMM YYYY",
          dateA11yLabel: "LL",
          monthYearA11yLabel: "MMMM YYYY",
        },
      },
    },
  ],
})
export class DsDatepickerFormatModule {}
